"use client";

import Header from "@/layout/headers/header";
import Wrapper from "@/layout/wrapper";
import Footer from "@/layout/footers/footer";
import { Suspense } from "react";
import Loading from "./loading";

export default function PrivacyPolicyPage() {
  return (
    <Wrapper>
      <Header />

      <main>
        <Suspense fallback={<Loading />}>
          <section
            style={{
              padding: "80px 16px",
              background: "#ffff",
            }}
          >
            <div className="container d-flex justify-content-center">

              <div className="policy-card">

                <h1 className="policy-title">
                  iMall Privacy Policy
                </h1>

                <p className="policy-sub">
                  Your privacy and data security are our highest priorities.
                </p>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>🔐 How We Use Your Data</h4>
                  <ol>
                    <li>To process and deliver your orders efficiently</li>
                    <li>To provide personalized product recommendations</li>
                    <li>To send updates about offers and services</li>
                    <li>To verify payments and prevent fraud</li>
                    <li>To improve overall user experience and analytics</li>
                  </ol>
                </div>

                <div className="policy-section">
                  <h4>📋 Information We Collect</h4>
                  <ol>
                    <li>Name and profile information</li>
                    <li>Mobile number, email address, billing and shipping address</li>
                    <li>Payment details (securely processed)</li>
                    <li>Device, browser, and usage activity data</li>
                    <li>Login information and order history</li>
                    <li>Location-related information where required</li>
                  </ol>
                </div>

                <div className="policy-section">
                  <h4>🍪 Cookies</h4>
                  <p>
                    iMall uses cookies to enhance your browsing experience.
                    You can manage or disable cookies anytime through your browser settings.
                  </p>
                </div>

                <div className="policy-section">
                  <h4>🛡️ Data Security</h4>
                  <p>
                    We use modern security technologies and encrypted servers
                    to protect your personal information from unauthorized access.
                  </p>
                </div>

                <div className="policy-section">
                  <h4>📝 Your Rights</h4>
                  <ol>
                    <li>You have the right to access your personal data</li>
                    <li>You may request correction or deletion of your data</li>
                    <li>You can restrict certain data processing activities</li>
                  </ol>
                </div>

                <div className="policy-note">
                  ⚠️ iMall does not knowingly collect personal information from individuals under 18 years of age.
                </div>

              </div>

            </div>
          </section>
        </Suspense>
      </main>

      <Footer />

      <style jsx>{`
        .policy-card {
          max-width: 860px;
          background: rgba(255,255,255,0.98);
          padding: 50px 40px;
          border-radius: 18px;
          border: 1px solid rgba(255,122,0,0.15);
          box-shadow: 0 12px 36px rgba(0,0,0,.08);
          transition: .3s ease;
        }

        .policy-card:hover{
          transform: translateY(-3px);
        }

        .policy-title{
          text-align:center;
          font-size:36px;
          font-weight:800;
          letter-spacing:1.2px;
          background: linear-gradient(135deg,#ff7a00,#ff3d00,#ff9800);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom:8px;
        }

        .policy-sub{
          text-align:center;
          color:#666;
          margin-bottom:35px;
          font-size:14px;
          letter-spacing:.6px;
        }

        .policy-section{
          margin-bottom:28px;
        }

        .policy-section h4{
          font-weight:700;
          margin-bottom:12px;
          color:#ff6a00;
        }

        .policy-section ol{
          padding-left:22px;
          margin:0;
        }

        .policy-section li{
          margin-bottom:8px;
          font-size:15px;
          color:#333;
          line-height:1.7;
        }

        .policy-section p{
          margin:0;
          font-size:15px;
          color:#444;
          line-height:1.7;
        }

        .policy-note{
          background:rgba(255,122,0,0.08);
          color:#d35400;
          padding:12px 16px;
          border-radius:12px;
          font-size:14px;
          margin-top:15px;
          border-left:4px solid #ff7a00;
        }

        @media(max-width:576px){
          .policy-card{
            padding:28px 18px;
          }
          .policy-title{
            font-size:26px;
          }
        }
      `}</style>

    </Wrapper>
  );
}
